<template>
  <div class="font-weight-bolder">
    <div class="text-uppercase">
      {{ api_data.Farmer.id }}#{{ api_data.Farmer.account_holder_number }}
    </div>
    <div class="text-capitalize" v-if="api_data.Farmer.basic_account_holder">
      - {{ api_data.Farmer.basic_account_holder || ' ' }} {{ api_data.Farmer.basic_account_holder_surname || ' ' }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'title-head',
  props: {
    api_data: Object
  },
}
</script>
